import React from 'react';
import './footer.style.scss';


const Footer =()=>(
<div className='footer-container'><p>
Израда <a href='https://marijana-portfolio-website.web.app/' target='_blank'  rel="noopener noreferrer">
    <img src='https://firebasestorage.googleapis.com/v0/b/marijana-portfolio-website.appspot.com/o/other-images%2Fmy-logo.png?alt=media&token=1388a26b-84c8-4eed-b70e-4da291db7eec'  alt='logo'/> 
    </a>, Завод за биоциде и медицинску екологију, 2020. Сва права задржана.
</p>
</div>
);

export default Footer;